var pug = require("!../../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (isForVNext, value) {if (value.score > 0) {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = value.score) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan\u003E\u002F10&nbsp;\u003C\u002Fspan\u003E";
if (isForVNext) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"iconba iconba-More quality-score-tooltip\""+pug.attr("title", value.title, true, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv" + (" class=\"status-image status_icon quality-score-detail\""+pug.attr("title", value.title, true, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E-\u003C\u002Fspan\u003E";
}}.call(this,"isForVNext" in locals_for_with?locals_for_with.isForVNext:typeof isForVNext!=="undefined"?isForVNext:undefined,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return pug_html;};
module.exports = template;